export const rootClass = 'calcZV';
export const cartClass = `${rootClass}__cart`;
export const partClass = `${rootClass}__cartPart`;
